module.exports = __webpack_public_path__ + "img/9.ae614c0a.jpg";